module.exports = __webpack_public_path__ + "img/medical_bricks.c84f19eb.jpg";